import "../Cursadas.css"
import { useEffect, useState } from "react";

import { getModulesByCourseId } from '../../../../Services/Modules.js';
import { getAllLecturesByModuleId } from '../../../../Services/Lecture.js';
import { getContnetsLectureId } from '../../../../Services/Content.js';

import check from '../../../../assets/iconos/check.png';


const INITIAL_PAGE = 0

export default function Modulos(props) {  
  const [page, setPage] = useState(INITIAL_PAGE)
  const [maxPages, setMaxPages] = useState(1);
  const [postPerPage, setPostPerPage] = useState(4)

  const [actualModule, setModule] = useState({});
  const [allModules, setModules] = useState([]);

  const [lectures, setLectures] = useState([]);
  const [finished, setFinished] = useState([]);

  const loadModules = async () => {
    let rsp = await getModulesByCourseId(props.courseInfo.id);

    if(rsp.Error == false){
      setModules(rsp.Data);
      setMaxPages(rsp.Data.length);
      setModule(rsp.Data[page]);

      let rspLecutres = await getAllLecturesByModuleId(rsp.Data[page].id);

      if(rspLecutres.Error == false){
        setLectures(rspLecutres.Data.lectures);
        setFinished(rspLecutres.Data.finished);
      }
    }
  }

  const currentUnit = [];
  const indexOfLastUnit = page * postPerPage;
  const indexOfFirstUnit = indexOfLastUnit - postPerPage;

  
  
  const handleNextPage = async () => {
    setPage((prevPage) => prevPage+1);
    setModule(allModules[page + 1]);

    let rspLecutres = await getAllLecturesByModuleId(allModules[page + 1].id);

      if(rspLecutres.Error == false){
        setLectures(rspLecutres.Data.lectures);
        setFinished(rspLecutres.Data.finished);
      }
  }
  const handlePrevPage = async () => {
    setPage((prevPage) => prevPage-1);
    setModule(allModules[page - 1]);

    let rspLecutres = await getAllLecturesByModuleId(allModules[page - 1].id);

      if(rspLecutres.Error == false){
        setLectures(rspLecutres.Data.lectures);
        setFinished(rspLecutres.Data.finished);
      }
  }

  const startLectureHandler = async (id, isFinished) => {
    let rsp = await getContnetsLectureId(id);
    
    if(rsp.Error == false){
      props.setIsFinished(isFinished);
      rsp.Data = {...rsp.Data, activityId:id, lecture_id: id}
      props.setActivitiesId(rsp.Data);
      props.setSubFrame('activity');
    }

  }

  useEffect(() => {
    loadModules();
  }, []);

  return (
    <div className="frame-modulo">
      <div className="modulo-title">
        <div className="materia-title">
          <h3 className="materia-title-big">M{page + 1}</h3>
          <p>{props.courseInfo.title} - {actualModule.title}</p>
        </div>
        <div className="tipo-de-entrega"><div className={"green-btn-2 sethoverdark setpointer " + (page===0 ? "nodisplay" : "")}  onClick={handlePrevPage}>Anterior</div>
          <div className={"green-btn-2 sethoverdark setpointer " + (page===maxPages - 1 ? "nodisplay" : "")}  onClick={handleNextPage}>Siguiente</div>
          <div className={"green-btn-2 sethoverdark setpointer "}>{maxPages}</div>
        </div>
      </div>
      <div className="modulos-container">
        {lectures.map((item, index) => (
          <div className="modulo-container" key={item.id}>
            <div className="modulo-content">
              <div className="numero-modulo">
                <h4>Clase {index + 1}</h4>
                {
                  finished != null ?
                    finished.find(({ id_lecture }) => id_lecture === item.id) ?
                    <>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Finalizada</p>
                      <img src={check} className="finishLectureCheck"/>
                    </>
                    :
                    <></>
                  :
                    <></>
                }
              </div>
              <div className="modulo-info">
                <h3>{item.title}</h3>
                <div className="modulo-desc">
                  <p>{item.description}</p>
                </div>
              </div>
              <div className="modulo-control">
                  <button className="white-btn setpointer" onClick={() => startLectureHandler(item.id, finished.find(({ id_lecture }) => id_lecture === item.id))}> <h4>Comenzar</h4></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}